<template>
    <div class="form-container">
        <div class="repayment-apply-title">产融还款专户申请开通</div>

<!--        <eui-steps :active="isActive" style="margin-bottom: 40px;margin-top: 25px" v-if="!(baseInfo.nextStage === 4 && baseInfo.accountStatus === 120)">-->
<!--            <eui-step title="提交审核" :description="baseInfo.nextStage === 3  ? '' : baseInfo.submitTime"></eui-step>-->
<!--            <eui-step :title="baseInfo.accountStatus > 111 &&  baseInfo.accountStatus !== 130 &&  baseInfo.accountStatus !== 141 ? '初审通过' : '待初审'"-->
<!--                      :description="baseInfo.accountStatus > 111 &&  baseInfo.accountStatus !== 130 &&  baseInfo.accountStatus !== 141? baseInfo.trialTime : ''"></eui-step>-->
<!--            <eui-step title="待复审"></eui-step>-->
<!--            <eui-step title="开户成功"></eui-step>-->
<!--        </eui-steps>-->
        <el-steps :active="isActive" align-center style="margin-bottom: 40px;margin-top: 25px" v-if="!(baseInfo.nextStage === 4 && baseInfo.accountStatus === 120)">
            <el-step title="提交审核" :description="baseInfo.nextStage === 3  ? '' : baseInfo.submitTime"></el-step>
            <el-step :title="baseInfo.accountStatus > 111 &&  baseInfo.accountStatus !== 130 &&  baseInfo.accountStatus !== 141 ? '初审通过' : '待初审'"
                     :description="baseInfo.accountStatus > 111 &&  baseInfo.accountStatus !== 130 &&  baseInfo.accountStatus !== 141? baseInfo.trialTime : ''"></el-step>
            <el-step title="待复审"></el-step>
            <el-step title="开户成功"></el-step>
        </el-steps>

        <!-- 第一步     3是 修改 资料-->
        <step-one v-if="baseInfo.nextStage === 0 || (baseInfo.nextStage === 3 && reSubmitBtn)"
                  :reSubmitBtn="reSubmitBtn"
                  :applyId="baseInfo.applyId"
                  @changeActive="changeActive"/>

        <!--审核失败-->
        <!--复审 失败 的 accountStatus === 141 又回到 提交 资料的  页面 -->
        <div v-if="baseInfo.nextStage === 3 && !reSubmitBtn" >
            <div class="flex-c margin-b20">
                <img src="../../../../assets/img/common/robot-mark.png" alt="" class="robot-mark" >
            </div>
            <div class="tip-wrapper flex margin-b20" >
                <img src="../../../../assets/img/common/icon-warning@2x.png" alt="" class="tip-left"/>
                <div class="tip-right margin-l10">
                    <div>{{userInfo.memberName}}，您好：</div>
                    <div v-if="this.baseInfo.accountStatus === 111">您提交的开户申请资料初审失败，请按提示内容修改申请后，再次提交申请。</div>
                    <div v-if="this.baseInfo.accountStatus === 141">您提交的开户申请资料复审失败，请按提示内容修改申请后，再次提交申请。</div>
                    <div>审核未通过原因：{{baseInfo.feedback}}</div>
                </div>
            </div>
            <div class="flex-c">
                <eui-btn  type="primary"  @click="toSetInfo">修改</eui-btn>
            </div>
        </div>


        <!--第二步  待复审 nextStage 是 2  -->
        <div v-if="(baseInfo.nextStage == 2 && baseInfo.accountStatus === 112) || (baseInfo.nextStage === 1 && baseInfo.accountStatus === 100)">
            <div class="flex-c margin-b20">
                <img src="../../../../assets/img/common/robot-empty.png" alt="" class="empty-img">
            </div>
            <div class="pass-wrapper"  >
                <div>{{userInfo.memberName}}，您好：</div>
                <div>您提交的产融还款专户开通申请资料我们已经收到，我们将尽快完成资料审核，请耐心等待，谢谢！</div>
            </div>
        </div>



        <!--成功了的-->
        <div class="open-tip" v-if="baseInfo.nextStage === 4 && baseInfo.accountStatus === 120 ">
                <div class="flex-c margin-b20">
                    <img src="../../../../assets/img/common/robot.png" alt="" />
                </div>
                <div class="flex-c">您的产融还款专户已开通</div>
                <div class="flex-c">专户开通时间 {{baseInfo.createTime}}</div>
        </div>
    </div>
</template>

<script>
    import stepOne from './common/stepOne';
    import api from '@/modules/projectA/api/pay/index';
    export default {
        name: "repaymentApplyActivation",
        components:{
            stepOne
        },
        data(){
            return{
                formData:{},
                isActive:1,
                baseInfo:{},
                userInfo:{},
                reSubmitBtn:false,
            }
        },
        methods:{
            toSetInfo(){
                this.reSubmitBtn = true;
                this.isActive = 1;
                // this.$router.push({path:'/repaymentApplyActivation'});
            },
            async financeAccountStatus(){
                let res = await api.financeAccountStatus();
                if(res.success){
                    this.baseInfo = res.data;
                    //0：未申请，1：提交待初审，2：初审通过待复审，3：初审/复审拒绝待修改资料，4：已开通
                    let nextStage = Number(this.baseInfo.nextStage);
                    if(nextStage === 3){
                        if(this.baseInfo.accountStatus === 111){//初审拒绝
                            this.isActive = 1;
                        }else if(this.baseInfo.accountStatus === 141){//复审拒绝
                            this.isActive = 1;
                        }
                    }else if(nextStage === 2){
                        this.isActive = 3;
                    }else if(nextStage === 1){
                        this.isActive = 2;
                    }else if(nextStage === 0){
                        this.isActive = 1;
                    } else{
                        this.isActive = Number(this.baseInfo.nextStage);
                    }
                 }
            },
            changeActive(step){
                this.isActive = step;
                if(step === 3){
                    this.reSubmitBtn = false;
                    this.baseInfo.nextStage = 3;
                    this.isActive = 1;
                }else{
                    this.financeAccountStatus();
                }
            },
        },
        mounted() {
            this.financeAccountStatus();
            this.userInfo = JSON.parse(localStorage.getItem('USERINFO'));
        }
    }
</script>

<style scoped lang="scss">
    .pass-wrapper{
        padding: 15px 10px;
        background-color: #E8EFFF;
        font-size: 14px;
        color: #333;
    }
    .open-tip{
        img{
            width: 120px;
            height: 120px;
        }
        div{
            font-size: 18px;
            font-weight: 500;
        }
    }
    .tip-wrapper{
        padding: 15px 10px;
        background-color: #fef0f1;
        font-size: 14px;
        color: #333;
        img{
            width: 18px;
            height: 18px;
        }

    }
    .empty-img{
        width: 204px;
        height: 120px;
    }
    .robot-mark{
        width: 120px;
        height: 120px;
    }
</style>